import { permissions } from '@/constants';
import PermissionStore from '@/store/PermissionStore';
import { StationTier } from '@/constants/enums';
import { BrandNamesSet } from '@/store/User/UserStore.utils';

export const canShowStationPrefix = (permissionStore: PermissionStore): boolean => {
  return permissionStore.isAuth(permissions.INTERNAL_ACCESS);
};

export const getTierTagPrefix = (stationTier: number, whiteLabelingTerms: BrandNamesSet) => {
  switch (stationTier) {
    case StationTier.Monitor:
      return whiteLabelingTerms.packagePrefixes.monitor;
    case StationTier.Optimize:
      return whiteLabelingTerms.packagePrefixes.optimize;
    default:
      return '';
  }
};
